import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-24 px-6 bg-darker relative" data-id="element-126">
      <div className="max-w-3xl mx-auto text-center" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-128">
          <p className="font-sans text-lg md:text-xl leading-relaxed text-cream/90 mb-8 font-light" data-id="element-129">
            Estás en un evento, un bar elegante o una cena. Llevas tu mejor
            vestido, tu carrera profesional es un éxito y tu inteligencia es
            superior a la media. Sin embargo, pasan los minutos y nadie se
            acerca. Te sientes como un fantasma en un lugar lleno de gente.
          </p>

          <div className="w-12 h-px bg-gold mx-auto mb-8 opacity-50" data-id="element-130"></div>

          <p className="font-serif text-2xl md:text-3xl leading-relaxed text-gold italic mb-8" data-id="element-131">
            "Ves a otra mujer al final de la barra. No es más joven que tú, ni
            más bella. Pero los hombres de alto valor gravitan hacia ella como
            si tuviera un interruptor invisible."
          </p>

          <p className="font-sans text-lg md:text-xl leading-relaxed text-cream/90 font-light" data-id="element-132">
            Ella no está esforzándose. Ella no está persiguiendo. Ella
            simplemente{' '}
            <span className="font-serif italic text-gold" data-id="element-133">está</span>.
          </p>
        </motion.div>
      </div>
    </section>;
}